import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import buildLoyaltySelectedUpgradeKey from 'loyalty/lib/benefits/buildLoyaltySelectedUpgradeKey'

function getSelectedLoyaltyTargetUpgradePackage(
  selectedPackageOption: OfferPackageOptionView,
  availablePackageOptions: Array<OfferPackageOptionView>,
  loyaltyTargetRoomUpgradesSelected: App.LoyaltyTargetRoomUpgradesSelected | undefined,
): OfferPackageOptionView | undefined {
  const targetUpgradeLePackageUniqueKey = selectedPackageOption.package.loyalty.targetUpgradePackageUniqueKey
  if (!targetUpgradeLePackageUniqueKey) return
  const targetUpgradePackage = availablePackageOptions.find(option => option.package.uniqueKey === targetUpgradeLePackageUniqueKey)

  if (
    !targetUpgradePackage ||
    !targetUpgradePackage?.capacityValid ||
    !targetUpgradePackage?.hotelAvailable
  ) return

  const selectedUpgradeKey = buildLoyaltySelectedUpgradeKey(
    selectedPackageOption.package,
    targetUpgradePackage.package,
  )

  const hasSelectedPackageTargetUpgrade = selectedUpgradeKey ? !!loyaltyTargetRoomUpgradesSelected?.[selectedUpgradeKey] : false

  if (!hasSelectedPackageTargetUpgrade) return

  return targetUpgradePackage
}

export default getSelectedLoyaltyTargetUpgradePackage
